const PermissionsV1 = {
  "ADDRESSES.REGISTRY.COUNTRIES": "api.v1.addresses.registry.countries",
  "ADDRESSES.COUNTRIES": "api.v1.addresses.countries",
  "ADDRESSES.REGISTRY.REGIONS": "api.v1.addresses.registry.regions",
  "ADDRESSES.REGISTRY.CHILD": "api.v1.addresses.registry.child",
  "ADDRESSES.REGISTRY.ATES": "api.v1.addresses.registry.ates",
  "ADDRESSES.REGISTRY.STREETS": "api.v1.addresses.registry.streets",
  "ADDRESSES.REGISTRY.STREET_PARENTS": "api.v1.addresses.registry.street-parents",
  "ADDRESSES.REGISTRY.STREET_TYPES": "api.v1.addresses.registry.street-types",
  "ADDRESSES.REGISTRY.STREET_FULL_PATH": "api.v1.addresses.registry.street-full-path",
  "ADDRESSES.REGISTRY.CACHE": "api.v1.addresses.registry.delete-cache",
  "ADDRESSES.STORE": "api.v1.addresses.store",
  "HRMIS.DEPARTMENTS.SEARCH": "api.v1.hrmis.departments.search",
  "HRMIS.STATES.SEARCH": "api.v1.hrmis.states.search",
  "HRMIS.STATES.PARENTS": "api.v1.hrmis.states.parents",
  "HRMIS.STATES.INDEX": "api.v1.hrmis.states.index",
  "HRMIS.STATES.PORTAL_ORGANIZATIONS": "api.v1.hrmis.states.portalOrganizations",
  "HRMIS.STATES.PORTAL_VISIBILITY": "api.v1.hrmis.states.portalVisibility",
  "LANG.GET_LIST": "api.v1.lang.get-list",
  "LANG.CREATE": "api.v1.lang.create",
  "LANG.UPDATE": "api.v1.lang.update",
  "NEWS.STORE": "api.v1.news.store",
  "NEWS.INDEX": "api.v1.news.index",
  "NEWS.FILE_TYPES": "api.v1.news.file-types",
  "NEWS.SEARCH": "api.v1.news.search",
  "NEWS.SHOW": "api.v1.news.show",
  "NEWS.UPDATE": "api.v1.news.update",
  "ADVANTAGES.INDEX": "api.v1.advantages.index",
  "ADVANTAGES.SHOW": "api.v1.advantages.show",
  "ADVANTAGES.UPLOAD": "api.v1.advantages.upload",
  "ADVANTAGES.STORE": "api.v1.advantages.store",
  "ADVANTAGES.UPDATE": "api.v1.advantages.update",
  "ADVANTAGES.DESTROY": "api.v1.advantages.destroy",
  "PORTAL_PAGES.INDEX": "api.v1.portal-pages.index",
  "PORTAL_PAGES.SHOW": "api.v1.portal-pages.show",
  "PORTAL_PAGES.STORE": "api.v1.portal-pages.store",
  "PORTAL_PAGES.UPDATE": "api.v1.portal-pages.update",
  "PORTAL_PAGES.DESTROY": "api.v1.portal-pages.destroy",
  "PORTAL_PAGES.ITEMS.INDEX": "api.v1.portal-pages.items.index",
  "PORTAL_PAGES.ITEMS.SHOW": "api.v1.portal-pages.items.show",
  "PORTAL_PAGES.ITEMS.STORE": "api.v1.portal-pages.items.store",
  "PORTAL_PAGES.ITEMS.UPDATE": "api.v1.portal-pages.items.update",
  "PORTAL_PAGES.ITEMS.DESTROY": "api.v1.portal-pages.items.destroy",
  "PORTAL_PAGES.REVISIONS.INDEX": "api.v1.portal-pages.revisions.index",
  "PORTAL_PAGES.REVISIONS.SHOW": "api.v1.portal-pages.revisions.show",
  "PORTAL_PAGES.REVISIONS.PUBLISH": "api.v1.portal-pages.revisions.publish",
  "HANDBOOKS.INDEX": "api.v1.handbooks.index",
  "HANDBOOKS.SHOW": "api.v1.handbooks.show",
  "HANDBOOKS.STORE": "api.v1.handbooks.store",
  "HANDBOOKS.UPDATE": "api.v1.handbooks.update",
  "HANDBOOKS.DESTROY": "api.v1.handbooks.destroy",
  "PERSONS.AWARDS.INDEX_BY_PERSON": "api.v1.persons.awards.index-by-person",
  "PERSONS.LOVZ.BY_PERSON_ID": "api.v1.persons.lovz.by-person-id",
  "PERSONS.LOVZ.CHECK": "api.v1.persons.lovz.check",
  "PERSONS.LOVZ.LAST_ACTIVE": "api.v1.persons.lovz.last-active",
  "PERSONS.REGISTRY_DIPLOMAS": "api.v1.persons.registry-diplomas",
  "PERSONS.AWARDS.SHOW_BY_PERSON": "api.v1.persons.awards.show-by-person",
  "PERSONS.AWARDS.STORE_BY_PERSON": "api.v1.persons.awards.store-by-person",
  "PERSONS.AWARDS.UPDATE_BY_PERSON": "api.v1.persons.awards.update-by-person",
  "PERSONS.AWARDS.DESTROY_BY_PERSON": "api.v1.persons.awards.destroy-by-person",
  "PERSONS.CHECK.SOCIAL_FUND": "api.v1.persons.check.socialFund",
  "PERSONS.CHECK.MVD": "api.v1.persons.check.mvd",
  "PERSONS.CHECK.HISTORY": "api.v1.persons.check.history",
  "PERSONS.MILITARIES.INDEX_BY_PERSON": "api.v1.persons.militaries.index-by-person",
  "PERSONS.FILES.INDEX": "api.v1.persons.files.index",
  "PERSONS.FILES.GROUPS": "api.v1.persons.files.groups",
  "PERSONS.FILES.CREATE": "api.v1.persons.files.create",
  "PERSONS.FILES.DESTROY": "api.v1.persons.files.destroy",
  "PERSONS.INDEX": "api.v1.persons.index",
  "PERSONS.RANKS.INDEX_BY_PERSON": "api.v1.persons.ranks.index-by-person",
  "PERSONS.RANKS.SHOW_BY_PERSON": "api.v1.persons.ranks.show-by-person",
  "PERSONS.RANKS.STORE_BY_PERSON": "api.v1.persons.ranks.store-by-person",
  "PERSONS.RANKS.UPDATE_BY_PERSON": "api.v1.persons.ranks.update-by-person",
  "PERSONS.RANKS.DESTROY_BY_PERSON": "api.v1.persons.ranks.destroy-by-person",
  "PERSONS.TRAININGS.INDEX_BY_PERSON": "api.v1.persons.trainings.index-by-person",
  "PERSONS.TRAININGS.SHOW_BY_PERSON": "api.v1.persons.trainings.show-by-person",
  "PERSONS.TRAININGS.STORE_BY_PERSON": "api.v1.persons.trainings.store-by-person",
  "PERSONS.TRAININGS.UPDATE_BY_PERSON": "api.v1.persons.trainings.update-by-person",
  "SELECTIONS.FORM.DOCUMENT_TYPES": "api.v1.selections.form.documentTypes",
  "SELECTIONS.INDEX": "api.v1.selections.index",
  "SELECTIONS.DESTROY": "api.v1.selections.destroy",
  "SELECTIONS.CLOSE": "api.v1.selections.close",
  "SELECTIONS.CANCEL": "api.v1.selections.cancel",
  "SELECTIONS.ITEM.PUBLISH": "api.v1.selections.item.publish",
  "SELECTIONS.FORM.RESERVE_TYPES": "api.v1.selections.form.reserveTypes",
  "SELECTIONS.VIEW": "api.v1.selections.view",
  "SELECTIONS.UPDATE.DATES": "api.v1.selections.update.dates",
  "SELECTIONS.FORM.RESERVE_POSITIONS": "api.v1.selections.form.reservePositions",
  "SELECTIONS.FORM.RESERVE_POSITION_GROUPS": "api.v1.selections.form.reservePositionGroups",
  "SELECTIONS.FORM.CONTACTS": "api.v1.selections.form.contacts",
  "SELECTIONS.STORE": "api.v1.selections.store",
  "SELECTIONS.FORM.TYPE_STAGES": "api.v1.selections.form.typeStages",
  "SELECTIONS.ITEM.ADD_STAGE": "api.v1.selections.item.addStage",
  "SELECTIONS.PROFILE.STAGES": "api.v1.selections.profile.stages",
  "SELECTIONS.FORM.TYPE_STAGES_INFO": "api.v1.selections.form.typeStagesInfo",
  "SELECTIONS.PROFILE.COMMISSIONS": "api.v1.selections.profile.commissions",
  "SELECTIONS.FORM.FORM_OPTIONS": "api.v1.selections.form.formOptions",
  "SELECTIONS.ITEM.ADD_COMMISSION": "api.v1.selections.item.addCommission",
  "SELECTIONS.ITEM.CHECK_COMMISSIONS": "api.v1.selections.item.checkCommissions",
  "SELECTIONS.ITEM.REMOVE_COMMISSION": "api.v1.selections.item.removeCommission",
  "SELECTIONS.PROFILE.DOCUMENT_TYPES": "api.v1.selections.profile.documentTypes",
  "SELECTIONS.FORM.REQUIREMENT_GROUPS": "api.v1.selections.form.requirementGroups",
  "SELECTIONS.FORM.REQUIREMENT_OPTIONS": "api.v1.selections.form.requirementOptions",
  "SELECTIONS.ITEM.ADD_REQUIREMENT": "api.v1.selections.item.addRequirement",
  "SELECTIONS.PROFILE.REQUIREMENT_FORMATS": "api.v1.selections.profile.requirementFormats",
  "SELECTIONS.FORM.SKILLS": "api.v1.selections.form.skills",
  "SELECTIONS.FORM.SKILL_GROUPS": "api.v1.selections.form.skillGroups",
  "SKILL_GROUPS.INDEX": "api.v1.skill_groups.index",
  "SKILL_GROUPS.STORE": "api.v1.skill_groups.store",
  "SKILL_GROUPS.SHOW": "api.v1.skill_groups.show",
  "SKILL_GROUPS.UPDATE": "api.v1.skill_groups.update",
  "SKILLS.SEARCH": "api.v1.skills.search",
  "SKILLS.INDEX": "api.v1.skills.index",
  "SKILLS.STORE": "api.v1.skills.store",
  "SKILLS.UPDATE": "api.v1.skills.update",
  "SKILLS.SHOW": "api.v1.skills.show",
  "SYNAK.OFFICES": "api.v1.synak.offices",
  "USERS.INDEX": "api.v1.users.index",
  "USERS.SHOW": "api.v1.users.show",
  "USERS.PROFILE.LOGINS": "api.v1.users.profile.logins",
  "USERS.STORE": "api.v1.users.store",
  "USERS.UPDATE": "api.v1.users.update",
  "USERS.GET_FOR_SELECT": "api.v1.users.getForSelect",
  "PERSONS.SHOW": "api.v1.persons.show",
  "PERSONS.ACCESS": "api.v1.persons.access",
  "PERSONS.STORE": "api.v1.persons.store",
  "PERSONS.UPDATE": "api.v1.persons.update",
  "DOCUMENT_SERIES.INDEX": "api.v1.document_series.index",
  "DOCUMENTS.TYPES.INDEX": "api.v1.documents.types.index",
  "INTEGRATOR.NATIONALITIES.INDEX": "api.v1.integrator.nationalities.index",
  "INTEGRATOR.NATIONALITIES.SHOW": "api.v1.integrator.nationalities.show",
  "INTEGRATOR.PIN_SERVICE": "api.v1.integrator.pin-service",
  "INTEGRATOR.ACTUAL_ADDRESS_SERVICE": "api.v1.integrator.actual-address",
  "PERSONS.EDUCATIONS.INDEX_BY_PERSON": "api.v1.persons.educations.index-by-person",
  "PERSONS.EDUCATIONS.SHOW_BY_PERSON": "api.v1.persons.educations.show-by-person",
  "PERSONS.EDUCATIONS.STORE_BY_PERSON": "api.v1.persons.educations.store-by-person",
  "PERSONS.EDUCATIONS.UPDATE_BY_PERSON": "api.v1.persons.educations.update-by-person",
  "PERSONS.EDUCATIONS.DESTROY_BY_PERSON": "api.v1.persons.educations.destroy-by-person",
  "PERSONS.EDUCATIONS.DOCUMENT_UPLOAD": "api.v1.persons.educations.document.upload-by-person",
  "PERSONS.EDUCATIONS.DOCUMENT_DESTROY": "api.v1.persons.educations.document.destroy-by-person",
  "PERSONS.EXPERIENCES.INDEX_BY_PERSON": "api.v1.persons.experiences.index-by-person",
  "PERSONS.EXPERIENCES.SHOW_BY_PERSON": "api.v1.persons.experiences.show-by-person",
  "PERSONS.EXPERIENCES.STORE_BY_PERSON": "api.v1.persons.experiences.store-by-person",
  "PERSONS.EXPERIENCES.UPDATE_BY_PERSON": "api.v1.persons.experiences.update-by-person",
  "PERSONS.EXPERIENCES.DESTROY_BY_PERSON": "api.v1.persons.experiences.destroy-by-person",
  "PERSONS.LANGUAGES.INDEX_BY_PERSON": "api.v1.persons.languages.index-by-person",
  "PERSONS.LANGUAGES.SHOW_BY_PERSON": "api.v1.persons.languages.show-by-person",
  "PERSONS.LANGUAGES.STORE_BY_PERSON": "api.v1.persons.languages.store-by-person",
  "PERSONS.LANGUAGES.UPDATE_BY_PERSON": "api.v1.persons.languages.update-by-person",
  "PERSONS.LANGUAGES.DESTROY_BY_PERSON": "api.v1.persons.languages.destroy-by-person",
  "PERSONS.PROGRESSES.INDEX_BY_PERSON": "api.v1.persons.progresses.index-by-person",
  "PERSONS.PROGRESSES.SHOW_BY_PERSON": "api.v1.persons.progresses.show-by-person",
  "PERSONS.PROGRESSES.STORE_BY_PERSON": "api.v1.persons.progresses.store-by-person",
  "PERSONS.PROGRESSES.UPDATE_BY_PERSON": "api.v1.persons.progresses.update-by-person",
  "PERSONS.PROGRESSES.DESTROY_BY_PERSON": "api.v1.persons.progresses.destroy-by-person",
  "PERSONS.RESERVES.INDEX": "api.v1.persons.reserves.index",
  "PERSONS.SKILLS.SHOW_BY_PERSON": "api.v1.persons.skills.show-by-person",
  "PERSONS.SKILLS.INDEX_BY_PERSON": "api.v1.persons.skills.index-by-person",
  "PERSONS.SKILLS.STORE_BY_PERSON": "api.v1.persons.skills.store-by-person",
  "PERSONS.SKILLS.BATCH_SAVE": "api.v1.persons.skills.batch-save",
  "PERSONS.TRAININGS.DESTROY_BY_PERSON": "api.v1.persons.trainings.destroy-by-person",
  "REFERENCE.SHOW_BY_KEY": "api.v1.reference.show-by-key",
  "REFERENCE.INDEX": "api.v1.reference.index",
  "REFERENCE.STORE": "api.v1.reference.store",
  "REFERENCE.UPDATE": "api.v1.reference.update",
  "REFERENCE.SHOW": "api.v1.reference.show",
  "REFERENCE.VALUES.INDEX": "api.v1.reference.values.index",
  "REFERENCE.VALUES.SEARCH": "api.v1.reference.values.search",
  "REFERENCE.VALUES.SHOW": "api.v1.reference.values.show",
  "REFERENCE.VALUES.STORE": "api.v1.reference.values.store",
  "REFERENCE.VALUES.UPDATE": "api.v1.reference.values.update",
  "RESERVE.ROUTES": "api.v1.reserve.routes",
  "RESERVE.PERSONS.INDEX": "api.v1.reserve.persons.index",
  "PERSONS.RESERVES.SHOW": "api.v1.persons.reserves.show",
  "PERSONS.RESERVES.UPDATE": "api.v1.persons.reserves.update",
  "PERSONS.RESERVES.HISTORY": "api.v1.persons.reserves.history",
  "PERSONS.RESERVES.TRANSFER": "api.v1.persons.reserves.transfer",
  "PERSONS.RESERVES.SYNAK.CANDIDATES": "api.v1.persons.reserves.synak.candidates",
  "PERSONS.RESERVES.SYNAK.APPLICATIONS": "api.v1.persons.reserves.synak.candidates.applications",
  "PERSONS.RESERVES.SYNAK.RESULTS": "api.v1.persons.reserves.synak.applications.results",
  "PERSONS.RESERVES.SYNAK.IMPORT": "api.v1.persons.reserves.synak.import",
  "PERSONS.UPDATE_PHOTO_BY_PERSON": "api.v1.persons.update-photo-by-person",
  "PERSONS.DESTROY": "api.v1.persons.destroy",
  "PERSONS.FAMILIES.INDEX_BY_PERSON": "api.v1.persons.families.index-by-person",
  "PERSONS.FAMILIES.SHOW_BY_PERSON": "api.v1.persons.families.show-by-person",
  "PERSONS.FAMILIES.STORE_BY_PERSON": "api.v1.persons.families.store-by-person",
  "PERSONS.FAMILIES.UPDATE_BY_PERSON": "api.v1.persons.families.update-by-person",
  "PERSONS.FAMILIES.DESTROY_BY_PERSON": "api.v1.persons.families.destroy-by-person",
  "PERSONS.SKILLS.STORE_SKILL_BY_PERSON": "api.v1.persons.skills.store-skill-by-person",
  "PERSONS.LOGINS.INDEX_BY_PERSON": "api.v1.persons.logins.index-by-person",
  "PERSONS.ADDRESSES.UPDATE_BY_PERSON": "api.v1.persons.addresses.update-by-person",
  "PERSONS.INDICATOR.GET_PERSON_INDICATOR": "api.v1.persons.indicator.get-person-indicator",
  "PERSONS.ITEM.ADD_INTEGRATOR_PHOTO": "api.v1.persons.item.add-integrator-photo",
  "PERSONS.FILTER.REFERENCES": "api.v1.persons.filter.references",
  "PERSONS.FILTER.SKILLS": "api.v1.persons.filter.skills",
  "PERSONS.RESERVES.RESERVE_TYPES": "api.v1.persons.reserves.reserve-types",
  "INTEGRATOR.CITIZENSHIP.INDEX": "api.v1.integrator.citizenship.index",
  "INTEGRATOR.CITIZENSHIP.SHOW": "api.v1.integrator.citizenship.show",
  "INTEGRATOR.PHOTO_SERVICE": "api.v1.integrator.photo-service",
  "SKILLS.IMPORT": "api.v1.skills.import",
  "SKILLS.DESTROY": "api.v1.skills.destroy",
  "ADDRESSES.REGISTRY.DELETE_CACHE": "api.v1.addresses.registry.delete-cache",
  "HRMIS.FORM.STATES": "api.v1.hrmis.form.states",
  "HRMIS.FORM.STATES.DEPARTMENTS": "api.v1.hrmis.form.states.departments",
  "HRMIS.FORM.DEPARTMENTS.POSITIONS": "api.v1.hrmis.form.departments.positions",
  "HRMIS.FORM.POSITIONS.ATTESTATION_EMPLOYEES": "api.v1.hrmis.form.positions.attestationEmployees",
  "HRMIS.FORM.SELECTIONS.EMPLOYEES": "api.v1.hrmis.form.selections.employees",
  "HRMIS.STATES.PROFILE.DEPARTMENTS": "api.v1.hrmis.states.profile.departments",
  "HRMIS.STATES.PROFILE.PERSONS": "api.v1.hrmis.states.profile.persons",
  "HRMIS.STATES.PROFILE.LEADERS": "api.v1.hrmis.states.profile.leaders",
  "HRMIS.STATES.PROFILE.NEWS": "api.v1.hrmis.states.profile.news",
  "HRMIS.STATES.PROFILE.SELECTIONS": "api.v1.hrmis.states.profile.selections",
  "HRMIS.STATES.PROFILE.CHILDREN": "api.v1.hrmis.states.profile.children",
  "HRMIS.STATES.PROFILE.SYSTEM_USERS": "api.v1.hrmis.states.profile.system-users",
  "HRMIS.STATES.PROFILE.REORGANIZATIONS": "api.v1.hrmis.states.profile.reorganizations",
  "HRMIS.STATES.GOV_TYPES.INDEX": "api.v1.hrmis.states.gov-types.index",
  "HRMIS.STATES.GROUPS.INDEX": "api.v1.hrmis.states.groups.index",
  "HRMIS.STATES.TYPES.INDEX": "api.v1.hrmis.states.types.index",
  "HRMIS.STATES.COMMISSIONS.INDEX": "api.v1.hrmis.states.commissions.index",
  "HRMIS.STATES.COMMISSIONS.SHOW": "api.v1.hrmis.states.commissions.show",
  "HRMIS.STATES.COMMISSIONS.STORE": "api.v1.hrmis.states.commissions.store",
  "HRMIS.STATES.COMMISSIONS.UPDATE": "api.v1.hrmis.states.commissions.update",
  "HRMIS.STATES.COMMISSIONS.DEACTIVATE": "api.v1.hrmis.states.commissions.deactivate",
  "HRMIS.STATES.COMMISSIONS.ACTIVATE": "api.v1.hrmis.states.commissions.activate",
  "HRMIS.DEPARTMENTS.INDEX": "api.v1.hrmis.departments.index",
  "HRMIS.DEPARTMENTS.GROUPS.INDEX": "api.v1.hrmis.departments.groups.index",
  "HRMIS.DEPARTMENTS.TYPES.INDEX": "api.v1.hrmis.departments.types.index",
  "HRMIS.DEPARTMENTS.PROFILE.POSITIONS": "api.v1.hrmis.departments.profile.positions",
  /*  <POSITIONS>  */
  "HRMIS.POSITIONS.TYPES": "api.v1.hrmis.positions.types",
  "HRMIS.POSITIONS.SEARCH": "api.v1.hrmis.positions.search",
  "HRMIS.POSITIONS.SHOW": "api.v1.hrmis.positions.show",
  "HRMIS.POSITIONS.INDEX": "api.v1.hrmis.positions.index",
  "HRMIS.POSITIONS.FORM.SCOPES": "api.v1.hrmis.positions.form.scopes",
  "HRMIS.POSITIONS.FORM.EMPLOYMENT_TYPES": "api.v1.hrmis.positions.form.employmentTypes",
  "HRMIS.POSITIONS.FORM.SKILL_GROUPS": "api.v1.hrmis.positions.form.skillGroups",
  "HRMIS.POSITIONS.FORM.SKILLS": "api.v1.hrmis.positions.form.skills",
  "HRMIS.POSITIONS.FORM.REQUIREMENT_GROUPS": "api.v1.hrmis.positions.form.requirementGroups",
  "HRMIS.POSITIONS.FORM.SELECTION_REQUIREMENT_GROUPS":
    "api.v1.hrmis.positions.form.selectionRequirementGroups",
  "HRMIS.POSITIONS.FORM.REQUIREMENT_OPTIONS": "api.v1.hrmis.positions.form.requirementOptions",
  "HRMIS.POSITIONS.FORM.RESERVE_TYPES": "api.v1.hrmis.positions.form.reserveTypes",
  "HRMIS.POSITIONS.PUBLISHES.INDEX": "api.v1.hrmis.positions.publishes.index",
  "HRMIS.POSITIONS.PUBLISHES.STORE": "api.v1.hrmis.positions.publishes.store",
  "HRMIS.POSITIONS.PUBLISHES.UPDATE": "api.v1.hrmis.positions.publishes.update",
  "HRMIS.POSITIONS.PROFILE.SCOPES": "api.v1.hrmis.positions.profile.scopes",
  "HRMIS.POSITIONS.PROFILE.SKILLS": "api.v1.hrmis.positions.profile.skills",
  "HRMIS.POSITIONS.PROFILE.REQUIREMENT_FORMATS":
    "api.v1.hrmis.positions.profile.requirementFormats",
  "HRMIS.POSITIONS.PROFILE.REQUIREMENTS": "api.v1.hrmis.positions.profile.requirements",
  "HRMIS.POSITIONS.ITEM.SYNC_SCOPES": "api.v1.hrmis.positions.item.sync-scopes",
  "HRMIS.POSITIONS.ITEM.REMOVE_SCOPES": "api.v1.hrmis.positions.item.remove-scopes",
  "HRMIS.POSITIONS.ITEM.ADD_SKILLS": "api.v1.hrmis.positions.item.add-skills",
  "HRMIS.POSITIONS.ITEM.REMOVE_SKILLS": "api.v1.hrmis.positions.item.remove-skills",
  "HRMIS.POSITIONS.ITEM.ADD_REQUIREMENT": "api.v1.hrmis.positions.item.add-requirement",
  "HRMIS.POSITIONS.ITEM.REMOVE_REQUIREMENT": "api.v1.hrmis.positions.item.remove-requirement",
  "HRMIS.POSITIONS.RECOMMENDATIONS.INDEX": "api.v1.hrmis.positions.recommendation.index",
  "HRMIS.POSITIONS.RECOMMENDATIONS.SHOW": "api.v1.hrmis.positions.recommendation.show",
  "HRMIS.POSITIONS.RECOMMENDATIONS.START": "api.v1.hrmis.positions.recommendation.start",
  "HRMIS.POSITIONS.RECOMMENDATIONS.PROFILE.PERSONS":
    "api.v1.hrmis.positions.recommendation.profile.persons",
  "HRMIS.POSITIONS.RECOMMENDATIONS.PROFILE.PERSONS.CATALOGS":
    "api.v1.hrmis.positions.recommendation.profile.persons.catalogs",
  /* <POSITIONS.REQUESTS> */
  "HRMIS.POSITIONS.REQUESTS.POSITIONS": "api.v1.hrmis.positions.profile.requests.positions",
  "HRMIS.POSITIONS.REQUESTS.INDEX": "api.v1.hrmis.positions.profile.requests.index",
  "HRMIS.POSITIONS.REQUESTS.STORE": "api.v1.hrmis.positions.profile.requests.store",
  "HRMIS.POSITIONS.REQUESTS.UPDATE": "api.v1.hrmis.positions.profile.requests.update",
  "HRMIS.POSITIONS.REQUESTS.COPY": "api.v1.hrmis.positions.profile.requests.copy",
  "HRMIS.POSITIONS.REQUESTS.CANDIDATES.STORE":
    "api.v1.hrmis.positions.profile.requests.candidates.request",
  "HRMIS.POSITIONS.REQUESTS.CANDIDATES.DELETE":
    "api.v1.hrmis.positions.profile.requests.candidates.release",
  "HRMIS.POSITIONS.REQUESTS.CANDIDATES.SELECT":
    "api.v1.hrmis.positions.profile.requests.candidates.select",
  "HRMIS.POSITIONS.REQUESTS.CANDIDATES.APPROVE":
    "api.v1.hrmis.positions.profile.requests.candidates.request.approve",
  "HRMIS.POSITIONS.REQUESTS.CANDIDATES.SEND":
    "api.v1.hrmis.positions.profile.requests.candidates.request.approve.send",
  "HRMIS.POSITIONS.REQUESTS.CANDIDATES.DECLINE":
    "api.v1.hrmis.positions.profile.requests.candidates.request.decline",
  "HRMIS.POSITIONS.REQUESTS.ON_AWAITING":
    "api.v1.hrmis.positions.profile.requests.on-awaiting-request",
  "HRMIS.POSITIONS.REQUESTS.MY": "api.v1.hrmis.positions.profile.requests.my",
  "HRMIS.POSITIONS.REQUESTS.ROUNDS": "api.v1.hrmis.positions.profile.requests.rounds",
  "HRMIS.POSITIONS.REQUESTS.STATUSES": "api.v1.hrmis.positions.profile.requests.statuses",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.SUMMARY":
    "api.v1.hrmis.positions.profile.requests.dashboard.summary",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.BY_STATUS":
    "api.v1.hrmis.positions.profile.requests.dashboard.by-status",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.BY_STATE":
    "api.v1.hrmis.positions.profile.requests.dashboard.by-state",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.BY_MONTH":
    "api.v1.hrmis.positions.profile.requests.dashboard.by-month",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.CONVERSION":
    "api.v1.hrmis.positions.profile.requests.dashboard.conversion",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.OVERDUE":
    "api.v1.hrmis.positions.profile.requests.dashboard.overdue",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.CANDIDATES.BY_STATUS":
    "api.v1.hrmis.positions.profile.requests.dashboard.candidates.by-status",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.CANDIDATES.BY_STATE":
    "api.v1.hrmis.positions.profile.requests.dashboard.candidates.by-state",
  "HRMIS.POSITIONS.REQUESTS.DASHBOARD.RATINGS":
    "api.v1.hrmis.positions.profile.requests.dashboard.ratings",
  /*  <POSITIONS/> */
  "RESERVE.TYPES.INDEX": "api.v1.reserve.types.index",
  "RESERVE.TYPES.STORE": "api.v1.reserve.types.store",
  "RESERVE.TYPES.SHOW": "api.v1.reserve.types.show",
  "RESERVE.TYPES.UPDATE": "api.v1.reserve.types.update",
  "RESERVE.TYPES.DESTROY": "api.v1.reserve.types.destroy",
  "RESERVE.FILTERED_RESERVE_TYPES": "api.v1.reserve.filtered-reserve-types",
  "RESERVE.TYPES.FORM.STAGES": "api.v1.reserve.types.form.stages",
  "RESERVE.TYPES.FORM.CRITERIA": "api.v1.reserve.types.form.criteria",
  "RESERVE.TYPES.FORM.OPTIONS": "api.v1.reserve.types.form.options",
  "RESERVE.TYPES.FORM.POSITION_TYPES": "api.v1.reserve.types.form.positionTypes",
  "RESERVE.TYPES.FORM.DOCUMENT_TYPES": "api.v1.reserve.types.form.documentTypes",
  "RESERVE.TYPES.FORM.DOCUMENT_GROUPS": "api.v1.reserve.types.form.documentGroups",
  "RESERVE.TYPES.FORM.FORM_OPTIONS": "api.v1.reserve.types.form.formOptions",
  "RESERVE.TYPES.FORM.REGISTER_CATEGORIES": "api.v1.reserve.types.form.registerCategories",
  "RESERVE.TYPES.FORM.REGISTER_POSITIONS": "api.v1.reserve.types.form.registerPositions",
  "RESERVE.TYPES.PROFILE.DOCUMENT_TYPES": "api.v1.reserve.types.profile.documentTypes",
  "RESERVE.TYPES.PROFILE.POSITIONS": "api.v1.reserve.types.profile.positions",
  "RESERVE.TYPES.PROFILE.STAGES": "api.v1.reserve.types.profile.stages",
  "RESERVE.TYPES.STAGES.SHOW": "api.v1.reserve.types.stages.show",
  "RESERVE.TYPES.ITEM.POSITIONS.ADD": "api.v1.reserve.types.item.positions.add",
  "RESERVE.TYPES.ITEM.TOGGLE_FILTER": "api.v1.reserve.types.item.toggleFilter",
  "RESERVE.TYPES.ITEM.STAGES.ENABLE": "api.v1.reserve.types.item.stages.enable",
  "RESERVE.TYPES.ITEM.ADD_DOCUMENT_TYPES": "api.v1.reserve.types.item.addDocumentTypes",
  "RESERVE.TYPES.STAGES.PROFILE.OPTIONS": "api.v1.reserve.types.stages.profile.options",
  "RESERVE.TYPES.STAGES.PROFILE.CRITERIAS": "api.v1.reserve.types.stages.profile.criterias",
  "RESERVE.TYPES.STAGES.ITEM.OPTIONS.ADD": "api.v1.reserve.types.stages.item.options.add",
  "RESERVE.TYPES.STAGES.ITEM.OPTIONS.TOGGLE": "api.v1.reserve.types.stages.item.options.toggle",
  "RESERVE.TYPES.STAGES.ITEM.CRITERIAS.ADD": "api.v1.reserve.types.stages.item.criterias.add",
  "RESERVE.TYPES.STAGES.ITEM.CRITERIAS.TOGGLE": "api.v1.reserve.types.stages.item.criterias.toggle",
  "RESERVE.POSITIONS.SEARCH": "api.v1.reserve.positions.search",
  "RESERVE.POSITIONS.SCOPES.INDEX": "api.v1.reserve.positions.scopes.index",
  "RESERVE.CRITERIA.INDEX": "api.v1.reserve.criteria.index",
  "USERS.ITEM.ADD_SELECTION_CONTACT": "api.v1.users.item.addSelectionContact",
  "USERS.CHANGE_PASSWORD": "api.v1.users.changePassword",
  "SELECTIONS.BY_STATUS_TYPE": "api.v1.selections.by-status-type",
  "SELECTIONS.STAGES.SYNAK_TESTS": "api.v1.selections.stages.synak-tests",
  "SELECTIONS.STAGES.TEST_TYPES": "api.v1.selections.stages.test-types",
  "SELECTIONS.STAGES.TESTS": "api.v1.selections.stages.tests",
  "SELECTIONS.STAGES.COUNT_TESTS_BY_TYPES": "api.v1.selections.stages.countTestsByTypes",
  "SELECTIONS.STAGES.CHECK_FOR_TESTINGS": "api.v1.selections.stages.checkForTestings",
  "SELECTIONS.STAGES.ADD_SYNAK_TEST": "api.v1.selections.stages.add-synak-test",
  "SELECTIONS.STAGES.DELETE_TEST": "api.v1.selections.stages.delete-test",
  "SELECTIONS.RESULTS": "api.v1.selections.results",
  "SELECTIONS.RESULTS.ATTESTATION_RECOMMEND": "api.v1.selections.results.attestationRecommend",
  "SELECTIONS.RESULTS.RESERVE_ADD": "api.v1.selections.results.reserveAdd",
  "SELECTIONS.RESULTS.OPTIONS": "api.v1.selections.results.options",
  "SELECTIONS.STAGES.RESULTS": "api.v1.selections.stages.results",
  "SELECTIONS.STAGES.INTERVIEW_OPTION": "api.v1.selections.stages.interviewOption",
  "SELECTIONS.STAGES.PROTOCOLS": "api.v1.selections.stages.protocols",
  "SELECTIONS.STAGES.COUNTERS": "api.v1.selections.stages.counters",
  "SELECTIONS.STAGES.RESULT_COUNTS": "api.v1.selections.stages.resultCounts",
  "SELECTIONS.STAGES.TESTING_OFFICE_COUNTS": "api.v1.selections.stages.testingOfficeCounters",
  "SELECTIONS.SELECTION.STAGES.CHANGE_DATES": "api.v1.selections.selection.stages.changeDates",
  "SELECTIONS.MESSAGES.SEND_MESSAGE": "api.v1.selections.messages.sendMessage",
  "SELECTIONS.STAGES.RESULTS.SYNAK": "api.v1.selections.stages.results.synak",
  "SELECTIONS.STAGES.RESULTS.ORDER": "api.v1.selections.stages.results.order",
  "SELECTIONS.STAGES.RESULTS.SHOW": "api.v1.selections.stages.results.show",
  "SELECTIONS.STAGES.RESULTS.CANCEL": "api.v1.selections.stages.results.cancel",
  "SELECTIONS.STAGES.RESULTS.PERSONS.MAKE_ABSENT":
    "api.v1.selections.stages.results.persons.makeAbsent",
  "SELECTIONS.STAGES.OPTIONS.GET_BY_SLUG": "api.v1.selections.stages.options.get-by-slug",
  "SELECTIONS.STAGES.OPTIONS.LIST": "api.v1.selections.stages.options.list",
  "SELECTIONS.STAGES.ITEM.FINISH": "api.v1.selections.stages.item.finish",
  "SELECTIONS.STAGES.ITEM.UPLOAD_PROTOCOL": "api.v1.selections.stages.item.upload-protocol",
  "SELECTIONS.STAGES.ITEM.CHECK_FOR_TESTINGS": "api.v1.selections.stages.item.checkForTestings",
  "SELECTIONS.STAGES.ITEM.DELETE_PROTOCOL": "api.v1.selections.stages.item.delete-protocol",
  "SELECTIONS.STAGES.INTERVIEW.VOTE": "api.v1.selections.stages.interview.vote",
  "SELECTIONS.STAGES.INTERVIEW.COMMISSION_VOTE":
    "api.v1.selections.stages.interview.commissionVote",
  "SELECTIONS.STAGES.INTERVIEW.CRITERIA_WITH_APPROVE":
    "api.v1.selections.stages.interview.criteriaWithApprove",
  "SELECTIONS.STAGES.INTERVIEW.CRITERIA_WITH_SCORE":
    "api.v1.selections.stages.interview.criteriaWithScore",
  "SELECTIONS.STAGES.INTERVIEW.TESTING_SCORE_WITH_INTERVIEW_AND_CHIEF_SCORES":
    "api.v1.selections.stages.interview.testingScoreWithInterviewAndChiefScores",
  "SELECTIONS.STAGES.INTERVIEW.COMMISSION_VOTE.UPDATE":
    "api.v1.selections.stages.interview.commissionVote.update",
  "SELECTIONS.STAGES.INTERVIEW.VOTE.UPDATE": "api.v1.selections.stages.interview.vote.update",
  "SELECTIONS.STAGES.INTERVIEW.CRITERIA_WITH_SCORE.UPDATE":
    "api.v1.selections.stages.interview.criteriaWithScore.update",
  "SELECTIONS.STAGES.INTERVIEW.CRITERIA_WITH_APPROVE.UPDATE":
    "api.v1.selections.stages.interview.criteriaWithApprove.update",
  "SELECTIONS.STAGES.INTERVIEW.TESTING_SCORE_WITH_INTERVIEW_AND_CHIEF_SCORES.UPDATE":
    "api.v1.selections.stages.interview.testingScoreWithInterviewAndChiefScores.update",
  "SELECTIONS.STAGES.SYNAK_APPLICATIONS.STORE": "api.v1.selections.stages.synak-applications.store",
  "SELECTIONS.STAGES.SYNAK_APPLICATIONS.RESEND":
    "api.v1.selections.stages.synak-applications.resend",
  "SELECTIONS.STAGES.SYNAK_APPLICATIONS.INDEX": "api.v1.selections.stages.synak-applications.index",
  "SELECTIONS.STAGES.SYNAK_APPLICATIONS.PENDING_APPS":
    "api.v1.selections.stages.synak-applications.pending-apps",
  "SELECTIONS.STAGES.SYNAK_APPLICATIONS.TESTING_EVENTS":
    "api.v1.selections.stages.synak-applications.testingEvents",
  "SELECTIONS.APPLICATIONS.APPROVE": "api.v1.selections.applications.approve",
  "SELECTIONS.APPLICATIONS.CHECK_MVD": "api.v1.selections.applications.checkMvd",
  "SELECTIONS.APPLICATIONS.CHECK_LOVZ": "api.v1.selections.applications.checkLovz",
  "SELECTIONS.APPLICATIONS.CONFIRM_LOVZ": "api.v1.selections.applications.confirmLovz",
  "SELECTIONS.APPLICATIONS.CHECK_DIPLOMA_REGISTRY":
    "api.v1.selections.applications.checkDiplomaRegistry",
  "SELECTIONS.APPLICATIONS.CHECK_DIPLOMA": "api.v1.selections.applications.checkDiploma",
  "SELECTIONS.APPLICATIONS.REJECT": "api.v1.selections.applications.reject",
  "SELECTIONS.APPLICATIONS.SPECIALITIES.REJECT":
    "api.v1.selections.applications.specialities.reject",
  "SELECTIONS.APPLICATIONS.STORE": "api.v1.selections.applications.store",
  "SELECTIONS.APPLICATIONS.DOCUMENTS": "api.v1.selections.applications.documents",
  "SELECTIONS.APPLICATIONS.DELETE": "api.v1.selections.applications.delete",
  "SELECTIONS.ITEM.CHECK_STAGES": "api.v1.selections.item.checkStages",
  "SELECTIONS.ITEM.SYNC_SCOPES": "api.v1.selections.item.syncScopes",
  "SELECTIONS.ITEM.REMOVE_SCOPES": "api.v1.selections.item.removeScopes",
  "SELECTIONS.ITEM.UN_PUBLISH": "api.v1.selections.item.unPublish",
  "SELECTIONS.ITEM.PIN": "api.v1.selections.item.pin",
  "SELECTIONS.ITEM.UN_PIN": "api.v1.selections.item.unPin",
  "SELECTIONS.ITEM.ADD_SKILLS": "api.v1.selections.item.addSkills",
  "SELECTIONS.ITEM.REMOVE_SKILLS": "api.v1.selections.item.removeSkills",
  "SELECTIONS.ITEM.SYNC_DOCUMENT_TYPES": "api.v1.selections.item.syncDocumentTypes",
  "SELECTIONS.ITEM.REMOVE_EMPLOYMENT_TYPES": "api.v1.selections.item.removeEmploymentTypes",
  "SELECTIONS.ITEM.SYNC_OFFICES": "api.v1.selections.item.syncOffices",
  "SELECTIONS.ITEM.SYNC_EMPLOYMENT_TYPES": "api.v1.selections.item.syncEmploymentTypes",
  "SELECTIONS.ITEM.REMOVE_DOCUMENT_TYPE": "api.v1.selections.item.removeDocumentType",
  "SELECTIONS.ITEM.REMOVE_OFFICE": "api.v1.selections.item.removeOffice",
  "SELECTIONS.ITEM.REMOVE_REQUIREMENT": "api.v1.selections.item.removeRequirement",
  "SELECTIONS.PROFILE.OFFICES": "api.v1.selections.profile.offices",
  "SELECTIONS.PROFILE.SKILLS": "api.v1.selections.profile.skills",
  "SELECTIONS.PROFILE.REQUIREMENTS": "api.v1.selections.profile.requirements",
  "SELECTIONS.PROFILE.APPLICATION_COUNT": "api.v1.selections.profile.applicationCount",
  "SELECTIONS.PROFILE.SCOPES": "api.v1.selections.profile.scopes",
  "SELECTIONS.PROFILE.EMPLOYMENT_TYPES": "api.v1.selections.profile.employmentTypes",
  "SELECTIONS.PROFILE.REQUIREMENTS_GROUPED": "api.v1.selections.profile.requirementsGrouped",
  "SELECTIONS.PROFILE.STAGES.STAGE": "api.v1.selections.profile.stages.stage",
  "SELECTIONS.FORM.USERS": "api.v1.selections.form.users",
  "SELECTIONS.FORM.STAGE_RESULT_FILTERS": "api.v1.selections.form.stageResultFilters",
  "SELECTIONS.FORM.APPLICATION_STATUSES": "api.v1.selections.form.applicationStatuses",
  "SELECTIONS.FORM.PERSONS": "api.v1.selections.form.persons",
  "SELECTIONS.FORM.DIPLOMA_TYPES": "api.v1.selections.form.diplomaTypes",
  "SELECTIONS.FORM.EMPLOYMENT_TYPES": "api.v1.selections.form.employmentTypes",
  "SELECTIONS.FORM.ADMISSION_GROUNDS": "api.v1.selections.form.admissionGrounds",
  "SELECTIONS.FORM.POSITION_SCOPES": "api.v1.selections.form.positionScopes",
  "SELECTIONS.FORM.STATUSES": "api.v1.selections.form.statuses",
  "SELECTIONS.FORM.STAGE_CRITERIAS": "api.v1.selections.form.stageCriterias",
  "INDICATOR_CATALOGS.GET_AVAILABLE": "api.v1.indicator_catalogs.getAvailable",
  "INDICATOR_CATALOGS.INDEX": "api.v1.indicator_catalogs.index",
  "INDICATOR_CATALOGS.SHOW": "api.v1.indicator_catalogs.show",
  "INDICATOR_CATALOGS.STORE": "api.v1.indicator_catalogs.store",
  "INDICATOR_CATALOGS.UPDATE": "api.v1.indicator_catalogs.update",
  "INDICATOR_CATALOGS.DESTROY": "api.v1.indicator_catalogs.destroy",
  "INDICATOR_SETTINGS.INDEX": "api.v1.indicator_settings.index",
  "INDICATOR_SETTINGS.SHOW": "api.v1.indicator_settings.show",
  "INDICATOR_SETTINGS.STORE": "api.v1.indicator_settings.store",
  "INDICATOR_SETTINGS.UPDATE": "api.v1.indicator_settings.update",
  "INDICATOR_SETTINGS.DESTROY": "api.v1.indicator_settings.destroy",
  "DOCUMENT_SERIES.SHOW": "api.v1.document_series.show",
  "DOCUMENT_SERIES.STORE": "api.v1.document_series.store",
  "DOCUMENT_SERIES.UPDATE": "api.v1.document_series.update",
  "AUTH_LEVELS.INDEX": "api.v1.auth_levels.index",
  "AUTH_LEVELS.SHOW": "api.v1.auth_levels.show",
  "AUTH_LEVELS.UPDATE": "api.v1.auth_levels.update",
  "AUTH_LEVELS.STORE": "api.v1.auth_levels.store",
  "AUTH_PERMISSIONS.INDEX": "api.v1.auth_permissions.index",
  "AUTH_PERMISSIONS.GROUP_BY_MODULES": "api.v1.auth_permissions.groupByModules",
  OFFICES: "api.v1.offices",
  TEST_TYPES: "api.v1.test-types",
  FILTER_TEST_TYPES: "api.v1.filter-test-types",
  "OFFICES.TESTING_EVENTS": "api.v1.offices.testingEvents",
  "SETTINGS.SEO.INDEX": "api.v1.settings.seo.index",
  "SETTINGS.SEO.STORE": "api.v1.settings.seo.store",
  "SETTINGS.SEO.SHOW": "api.v1.settings.seo.show",
  "SETTINGS.SEO.UPDATE": "api.v1.settings.seo.update",
  "SETTINGS.SEO.DESTROY": "api.v1.settings.seo.destroy",
  "PERSONS.ATTESTATIONS.INDEX": "api.v1.persons.attestations.index",
  "PERSONS.ATTESTATIONS.SHOW": "api.v1.persons.attestations.show",
  "PERSONS.ATTESTATIONS.UPDATE": "api.v1.persons.attestations.update",
  "PERSONS.ATTESTATIONS.DISMISS": "api.v1.persons.attestations.dismiss",
  "PERSONS.ATTESTATIONS.ATTESTATION_TYPES": "api.v1.persons.attestations.attestation-types",
  "PERSONS.EXPORTS.RESUME_CANDIDATE": "api.v1.persons.exports.resumeCandidate",
  "PERSONS.MESSAGES.COMMENT": "api.v1.persons.messages.comment",
  "SYNAK.FILTER_TEST_TYPES": "api.v1.synak.filter-test-types",
  "RESERVE.TYPES.DELETE": "api.v1.reserve.types.delete",
  "RESERVE.TYPES.ITEM.TOGGLESTATUS": "api.v1.reserve.types.item.toggleStatus",
  "RESERVE.TYPES.RESTORE": "api.v1.reserve.types.restore",
  "RESERVE.TYPES.PROFILE.AUTHLEVELS": "api.v1.reserve.types.profile.authLevels",
  "RESERVE.TYPES.ITEM.AUTH_LEVEL.REMOVE": "api.v1.reserve.types.item.auth_level.remove",
  "RESERVE.TYPES.FORM.AUTHLEVELS": "api.v1.reserve.types.form.authLevels",
  "RESERVE.TYPES.ITEM.AUTH_LEVEL.ADDAUTHLEVEL": "api.v1.reserve.types.item.auth_level.addAuthLevel",
  "RESERVE.TYPES.POSITIONS.TOGGLESTATUS": "api.v1.reserve.types.positions.toggleStatus",
  "RESERVE.TYPES.POSITIONS.DELETE": "api.v1.reserve.types.positions.delete",
  "SELECTIONS.RESULTS.ATTESTATIONS": "api.v1.selections.results.attestations",
  "SELECTIONS.RESULTS.RESERVES": "api.v1.selections.results.reserves",
  "ATTESTATION.ROUTES": "api.v1.attestation.routes",
  "PERSONS.RESERVES.RESERVE_TYPES.RESERVE.ADD": "api.v1.persons.reserves.reserve-types.reserve.add",
  "PERSONS.RESERVES.RESERVE_TYPES.RESERVE.REMOVE":
    "api.v1.persons.reserves.reserve-types.reserve.remove",
  "PERSONS.SELECTIONS.APPLICATIONSSELECTIONS.APPLICATIONS":
    "api.v1.persons.selections.applicationsselections.applications",
  "SELECTIONS.HISTORIES": "api.v1.selections.histories",
  "PERSONS.SKILLS.DESTROY_BY_PERSON_ID": "api.v1.persons.skills.destroy-by-person-id",
  "PERSONS.SCIENTIFIC_WORKS.INDEX_BY_PERSON": "api.v1.persons.scientific-works.index-by-person",
  "PERSONS.SCIENTIFIC_WORKS.SHOW_BY_PERSON_ID": "api.v1.persons.scientific-works.show-by-person-id",
  "PERSONS.SCIENTIFIC_WORKS.STORE_BY_PERSON_ID":
    "api.v1.persons.scientific-works.store-by-person-id",
  "PERSONS.SCIENTIFIC_WORKS.UPDATE_BY_PERSON_ID":
    "api.v1.persons.scientific-works.update-by-person-id",
  "PERSONS.SCIENTIFIC_WORKS.DESTROY_BY_PERSON_ID":
    "api.v1.persons.scientific-works.destroy-by-person-id",
  "STATISTICS.OPEN_DATA.RESERVE.SEND_STATS": "api.v1.statistics.open-data.reserve.send-stats",
  "HRMIS.STATES.VIEW": "api.v1.hrmis.states.view",
  "HRMIS.STATES.SYNC_EMPLOYEE_COUNTS": "api.v1.hrmis.states.syncEmployeeCounts",
  "HRMIS.DEPARTMENTS.SYNC_EMPLOYEE_COUNTS":
    "api.v1.hrmis.departments.profile.positionsSyncEmployeeCount",
  "HRMIS.POSITIONS.SYNC_EMPLOYEES": "api.v1.hrmis.positions.item.syncEmployees",
  "HRMIS.POSITIONS.REQUESTS.ON_AWAITING.STATUSES":
    "api.v1.hrmis.positions.profile.requests.on-awaiting-request-statuses",
  "STATISTICS.SELECTION.COUNTS_BY_TYPES": "api.v1.statistics.selection.countsByTypes",
  "STATISTICS.SELECTION.COUNTS_BY_MONTHS": "api.v1.statistics.selection.countsByMonths",
  "STATISTICS.SELECTION.COUNTS_BY_MONTHS_ADVANCED":
    "api.v1.statistics.selection.countsByMonthsAdvanced",
  "STATISTICS.RESERVE.COUNTS_BY_POSITIONS": "api.v1.statistics.reserve.countsByPositions",
  "STATISTICS.RESERVE.FORM.RESERVE_POSITIONS": "api.v1.statistics.reserve.form.reservePositions",
  "STATISTICS.RESERVE.FORM.MONTH_YEAR_LIST": "api.v1.statistics.reserve.form.monthYearList",
  "STATISTICS.RESERVE.COUNTS_BY_TYPES": "api.v1.statistics.reserve.countsByTypes",
  "STATISTICS.PERSON.COUNTS_EMPLOYEE": "api.v1.statistics.person.countsEmployee",
  "STATISTICS.PERSON.COUNTS": "api.v1.statistics.person.counts",
  "SELECTIONS.PROFILE.APPLICATIONS": "api.v1.selections.profile.applications",
  SELECTION_DATES_EDIT: "selection_dates_edit",
  REPORTS_PERMISSION: "reports_permission",
  REPORTS_LIST: "api.v1.report.reports",
  REPORT_OFFICE_LIST: "api.v1.report.offices",
  REPORT_POSITION_LIST: "api.v1.report.positions",
  REPORTS_DOWNLOAD: "api.v1.report.download",
  "SELECTIONS.PENDING.TYPES": "api.v1.selections.pending.types",
  "SELECTIONS.PENDING.STATUSES": "api.v1.selections.pending.statuses",
  "SELECTIONS.PENDING.INDEX": "api.v1.selections.pending.index",
  "SELECTIONS.PENDING.STORE": "api.v1.selections.pending.store",
  "SELECTIONS.PENDING.DONE": "api.v1.selections.pending.done",
  "SELECTIONS.PENDING.ACCEPT": "api.v1.selections.pending.accept",
  "SELECTIONS.PENDING.REJECT": "api.v1.selections.pending.reject",
  "RATING.INDEX": "api.v1.ratings.index",
  // "RATING.DOWNLOAD": "api.v1.ratings.download",
  "RATING.STATUSES": "api.v1.ratings.statuses",
  "RATING.TYPES": "api.v1.ratings.types",
  "RATING.DIPLOMA_TYPES": "api.v1.ratings.diploma-types",
  "RATING.ROUTES": "api.v1.ratings.routes",
  "RATING.UPDATE": "api.v1.ratings.update",
  "RATING.PREFERENCES": "api.v1.ratings.preferences",
  "RATING.REQUESTS": "api.v1.ratings.requests",
  "RATING.EXPERIENCES": "api.v1.ratings.experiences",
  "POSITION_RATING_ALERTS.INDEX": "api.v1.position-rating-alerts.index",
  "POSITION_RATING_ALERTS.SEARCH": "api.v1.position-rating-alerts.search",
  "POSITION_RATING_ALERTS.STORE": "api.v1.position-rating-alerts.store",
  "POSITION_RATING_ALERTS.UPDATE": "api.v1.position-rating-alerts.update",
  "POSITION_RATING_ALERTS.DESTROY": "api.v1.position-rating-alerts.destroy",
  "DIGITAL_COMPETENCY.REPORT.DOWNLOAD": "api.v1.ratings.testing.report.download",
  "DIGITAL_COMPETENCY.TESTING_RATING": "api.v1.ratings.testing.index",
  "SELECTIONS.POSITIONS.CATEGORIES": "api.v1.selections.positions.categories",
};

export default PermissionsV1;
